
 //production
 var admin      =   "https://lc0khqflre.execute-api.ap-south-1.amazonaws.com/dev/api/";     //admin
 
 var service    =   "https://iev1ltgkqg.execute-api.ap-south-1.amazonaws.com/dev/api/";     //service

 var rider      =   "https://77rmhgxew9.execute-api.ap-south-1.amazonaws.com/dev/api/";     //rider   

 var driver     =   "https://b8x89ujjg3.execute-api.ap-south-1.amazonaws.com/dev/api/";     //driver

 var master     =   "https://cyz8kn7pdk.execute-api.ap-south-1.amazonaws.com/dev/api/";     //master  use this for new api creation

 
//development
 var local      =   "http://localhost:3000/dev/api/";

// import Vue from 'vue'
//var querystring = require('querystring');
import axios from 'axios'
// import store from '../store'

import { authHeader } from '../helpers/auth-header';

let header = authHeader()
// var header={
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": localStorage.getItem("token")
// }};
export default {
    
    login(data)
    {
        return axios.post(admin + "user/userlogin", JSON.stringify(data),  header)
    },
    vehiclelist(data)
    {
        return axios.post(admin + "vehicles/adminVehicleList", JSON.stringify(data),  header)
    },
    dashboardRideData(data)
    {
        return axios.post(admin + "user/adminDashboardRideData", JSON.stringify(data),  header)
    },
    dashboardcount(data)
    {
        return axios.post(admin + "user/adminDashboardData", JSON.stringify(data),  header)
    },
    userlist(data)
    {
        return axios.post(admin + "user/userList", JSON.stringify(data),  header)
    },
    
    sosAlertMaster(data)
    {
        return axios.post(admin + "user/adminuserNotification", JSON.stringify(data),  header)
    },
    todaysTravelListDashboard(data)
    {//Data/subjectlist
        return axios.post(admin + "userRide/todaysTravelListDashboard",JSON.stringify(data),   header)
    },
    adminUserProfile(data)
    {//Data/subjectlist
        return axios.post(admin + "user/adminUserProfile",JSON.stringify(data),   header)
    },
    vehicleDriverList(data)
    {
        return axios.post(admin + "vehicles/vehicleDriverList",JSON.stringify(data),   header)
    },
    searchDriverVehicleAdd(data)
    {
        return axios.post(admin + "user/searchDriverVehicleAdd",JSON.stringify(data),   header)
    },
    searchGroupVehicleAdd(data)
    {
        return axios.post(admin + "user/searchGroupVehicleAdd",JSON.stringify(data),   header)
    },
    addDriverVehicle(data)
    {
        return axios.post(admin + "vehicles/addDriverVehicle",JSON.stringify(data),   header)
    },
    activateVehicleDriver(data)
    {
        return axios.post(admin + "userRide/activateVehicleDriver",JSON.stringify(data),   header)
    },
    rideMaster(data)
    {
        return axios.post(admin + "user/userRideMaster",JSON.stringify(data),   header)
    },
    deleteusermaster(data)
    {
        return axios.post(admin + "user/deleteUser", JSON.stringify(data),  header)
    },
    adminsendpushnotification(data)
    {
        return axios.post(admin + "user/adminsendpushnotification", JSON.stringify(data),  header)
    },
    superset_login()
    {
        return axios.post('http://3.110.177.178:8088/api/v1/security/login',JSON.stringify({  "password": "admin",
        "provider": "db",
        "refresh": true,
        "username": "admin"}),header)
    },
    superset_api(data)
    {
        return axios.post(admin+"user/getsupersettoken", JSON.stringify(data),  header);       
           
    } ,
    group_list(data)
    {
        return axios.post(admin+"user/groupList", JSON.stringify(data),  header); 
    },
    delete_group_master(data)
    {
        return axios.post(admin+"user/deletegroupmaster", JSON.stringify(data),  header)
    },
    geocodelats(data)
    {
        return axios.post(admin+"user/geocodelats", JSON.stringify(data),  header);
    },
    geocodelocationdetails(data)
    {
        return axios.post(admin+"user/geocodelocationdetails", JSON.stringify(data),  header);
    },
    addgroup(data)
    {
        return axios.post(admin+"user/addgroup", JSON.stringify(data),  header)
    },
    editgroup(data)
    {
        return axios.post(admin+"user/edit_group", JSON.stringify(data),  header)
    },
    groupUserListget(data)
    {
        return axios.post(admin+"vehicles/groupUserList", JSON.stringify(data),  header)
    },
    groupVehicleListget(data)
    {
        return axios.post(admin+"vehicles/groupVehicleList", JSON.stringify(data),  header)
    },
    addUsersToGroup(data)
    {
        return axios.post(admin+"vehicles/addUsersToGroup", JSON.stringify(data),  header)
    },
    mappedVehcielGroup(data)
    {
        return axios.post(admin+"vehicles/mappedVehcielGroup", JSON.stringify(data),  header)
    },
    unmappedVehcielGroup(data)
    {
        return axios.post(admin+"vehicles/unmappedVehcielGroup", JSON.stringify(data),  header)
    },
    add_group_stops(data)
    {
        return axios.post(admin+"user/add_group_stops", JSON.stringify(data),  header)
    },
    delete_group_stops(data)
    {
        return axios.post(admin+"user/delete_group_stops", JSON.stringify(data),  header)
    },
    getMenuList(data)
    {
        return axios.post(admin+"user/getMenuList", JSON.stringify(data),  header)
    },
    getRoleList(data)
    {
        return axios.post(admin+"user/getRoleList", JSON.stringify(data),  header)
    },
    addrole(data)
    {
        return axios.post(admin +"user/addrole", JSON.stringify(data),  header)
    },
    editrole(data)
    {
        return axios.post(admin +"user/editrole", JSON.stringify(data),  header)
    },
    deleterolemaster(data)
    {
        return axios.post(admin +"user/deleterole", JSON.stringify(data),  header)
    },
    getMenuListMaster(data)
    {
        return axios.post(admin+"user/getMenuListMaster", JSON.stringify(data),  header)
    },
    addmenu(data)
    {
        return axios.post(admin +"user/addmenu", JSON.stringify(data),  header)
    },
    editmenu(data)
    {
        return axios.post(admin +"user/editmenu", JSON.stringify(data),  header)
    },
    deletemenumaster(data)
    {
        return axios.post(admin +"user/deletemenu", JSON.stringify(data),  header)
    },
    saveRoleMenuMapping(data)
    {
        return axios.post(admin+"user/saveRoleMenuMapping", JSON.stringify(data),  header)
    },
    user_rolelist(data)
    {
        return axios.post(admin+"user/user_rolelist", JSON.stringify(data),  header)
    },
    addclient(data)
    {
        return axios.post(admin+"user/addclient", JSON.stringify(data),  header)
    },
    editclient(data)
    {
        return axios.post(admin+"user/editclient", JSON.stringify(data),  header)
    },
    edituser(data)
    {
        return axios.post(admin+"user/edituser", JSON.stringify(data),  header)
    },
    regUser(data)
    {
        return axios.post(admin+"user/regUser", JSON.stringify(data),  header)
    },
    clientdepartmentlist(data)
    {
        return axios.post(admin+"clientdepartment/clientdepartmentlist", JSON.stringify(data),  header)
    },
    clientDepartmentAdd(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentAdd", JSON.stringify(data),  header)
 
    },
    clientDepartmentUpdate(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentUpdate", JSON.stringify(data),  header)

    },
    client_DepartmentDelete(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentDelete", JSON.stringify(data),  header)

    },
    groupList(data)
    {
        return axios.post(admin+"user/groupList", JSON.stringify(data),  header)

    },
    clientDepartmentMappGroup(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentMappGroup", JSON.stringify(data),  header)

    },
    getclientist(data)
    {
        return axios.post(admin+"user/getclientist", JSON.stringify(data),  header)
    },
    department_grouplist(data)
    {
        return axios.post(admin+"user/department_group_list", JSON.stringify(data),  header)
    },

    editvehicle(data)
    {   
        return axios.post(admin+"vehicles/vehicleEdit", JSON.stringify(data),  header)
    },
    addvehicle(data)
    {   
        return axios.post(admin+"vehicles/vehicleReg", JSON.stringify(data),  header)
    },
    vehicle_type_master(data)
    {   
        return axios.post(admin+"vehicles/get_vehicle_type_master", JSON.stringify(data),  header)
    },
    vehicle_list_by_client_id(data)
    {   
        return axios.post(admin+"vehicles/vehicle_list_by_client_id", JSON.stringify(data),  header)
    },
    searchhireVehicleAdd(data)
    {   
        return axios.post(admin+"user/searchhireVehicleAdd", JSON.stringify(data),  header)
    },
    

    uploadFile(data)
    {
       return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header)
    },

    HireVehicleList(data)
    {
       return axios.post(admin + "vehicles/HireVehicleList", JSON.stringify(data),  header)
    },

    vehicles_group_list(data)
    {
       return axios.post(admin + "vehicles/vehicles_group_list", JSON.stringify(data),  header)
    },

    unmap_vehicle_route(data)
    {
       return axios.post(admin + "vehicles/unmap_vehicle_route", JSON.stringify(data),  header)
    },
    get_client_type_master(data)
    {
       return axios.post(admin + "vehicles/get_client_type_master", JSON.stringify(data),  header)
    },
    clientDashboard(data)
    {
       return axios.post(admin + "user/clientDashboardData", JSON.stringify(data),  header)
    },
    fmDashboardData(data)
    {
       return axios.post(admin + "user/fmDashboardData", JSON.stringify(data),  header)
    },
    ServiceList(data)
    {
       return axios.post(admin + "vehicles/UserServiceList", JSON.stringify(data),  header)
    },
    serviceRequestList(data)
    {
       return axios.post(admin + "user/serviceRequestList", JSON.stringify(data),  header)
    },
    deleteservicedata(data)
    {
       return axios.post(admin + "vehicles/deleteservice", JSON.stringify(data),  header)
    },
    UserServicereqList(data)
    {
       return axios.post(admin + "vehicles/UserServicerequestList", JSON.stringify(data),  header)
    },
    get_RideData(data)
    {
       return axios.post(admin + "user/getRideDataLive", JSON.stringify(data),  header)
    },
    bulkvehicleupload_save(data)
    {
       return axios.post(admin + "vehicles/bulkvehicleupload", JSON.stringify(data),  header)
    },
    bulkuserupload_save(data)
    {
       return axios.post(admin + "user/bulkuserupload", JSON.stringify(data),  header)
    },
    deletevehicle(data)
    {
       return axios.post(admin + "vehicles/vehicleDelete", JSON.stringify(data),  header)
    },
    RoleGroupMasterList(data)
    {
       return axios.post(admin + "user/RoleGroupMasterList", JSON.stringify(data),  header)
    },

    departmentVehicleListget(data)
    {
        return axios.post(admin+"vehicles/departmentVehicleList", JSON.stringify(data),  header)
    },
    mappedVehcielDepartment(data)
    {
        return axios.post(admin+"vehicles/mappedVehcielDepartment", JSON.stringify(data),  header)
    },
    getStateData(data)
    {
        return axios.post(service+"masters/getStateData", JSON.stringify(data),  header)
    },
    getBlockData(data)
    {
        return axios.post(service+"masters/getBlockData", JSON.stringify(data),  header)
    },
    getVillageData(data)
    {
        return axios.post(service+"masters/getVillageData", JSON.stringify(data),  header)
    },
    getVillageDataList(data)
    {
        return axios.post(service+"masters/getVillageDataList", JSON.stringify(data),  header)
    },


    getFamilyData(data)
    {
        return axios.post(service+"masters/getFamilyData", JSON.stringify(data),  header)
    },
    getRideGroupStopData(data)
    {
        return axios.post(service+"ride/userRideDetails", JSON.stringify(data),  header)
    },
    getComplaintList(data)
    {
        return axios.post(service+"masters/getComplaintList", JSON.stringify(data),  header)
    },
    getComplaintTypeList(data)
    {
        return axios.post(service+"masters/getComplaintTypeList", JSON.stringify(data),  header)
    },
    getComplaintStatusList(data)
    {
        return axios.post(service+"masters/getComplaintStatusList", JSON.stringify(data),  header)
    },
    getMediaType(data)
    {
        return axios.post(service+"media/GetMediaType", JSON.stringify(data),  header)
    },
    getMediaList(data)
    {
        return axios.post(service+"media/GetMediaList", JSON.stringify(data),  header)
    },
    AddMedia(data)
    {
        return axios.post(service+"media/AddMedia", JSON.stringify(data),  header)
    },
    EditMedia(data)
    {
        return axios.post(service+"media/EditMedia", JSON.stringify(data),  header)
    },
    DeleteMedia(data)
    {
        return axios.post(service+"media/DeleteMedia", JSON.stringify(data),  header)
    },
    upload_to_AWS(data)
    {
         return axios.post(admin+"getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header);
    },
    Get_Media(data)
    {
         return axios.post(service+"masters/GetMedia", JSON.stringify(data),  header);
    },
    VehicleDeviceMappingList(data)
    {
        return axios.post(rider + "vehicles/vehicleDeviceMappingList", JSON.stringify(data),  header)
    },
    AddVehicleDeviceMapp(data)
    {
        return axios.post(rider + "vehicles/vehicleDeviceMapp", JSON.stringify(data),  header)
    },
    EditVehicleDeviceMapp(data)
    {
        return axios.post(rider + "vehicles/vehicleDeviceMappEdit", JSON.stringify(data),  header)
    },
    DeleteVehicleDeviceMapp(data)
    {
        return axios.post(rider + "vehicles/deleteVehicleDeviceMapp", JSON.stringify(data),  header)
    },
    GetAdList(data)
    {
        return axios.post(rider + "vehicles/getAdvertizementList", JSON.stringify(data),  header)
    },
    AdvertizementAdd(data)
    {
        return axios.post(rider + "vehicles/advertizementAdd", JSON.stringify(data),  header)
    },
    AdvertizementEdit(data)
    {
        return axios.post(rider + "vehicles/advertizementEdit", JSON.stringify(data),  header)
    },
    AdvertizementDelete(data)
    {
        return axios.post(rider + "vehicles/advertizementDelete", JSON.stringify(data),  header)
    },
    ApproveRejectShorts(data)
    {
        return axios.post(admin+"user/approveRejectShorts", JSON.stringify(data),  header)
    },
    SongList(data)
    {
        return axios.post(admin+"user/SongMasterList", JSON.stringify(data),  header)
    },
    songCategoryList(data)
    {
        return axios.post(admin+"user/songCategoryList", JSON.stringify(data),  header)
    },
    songAlbumList(data)
    {
        return axios.post(admin+"user/songAlbumList", JSON.stringify(data),  header)
    },
    singerList(data)
    {
        return axios.post(admin+"user/singerList", JSON.stringify(data),  header)
    },
    addAlbum(data)
    {
        return axios.post(admin+"user/addAlbum", JSON.stringify(data),  header)
    },
    addCategory(data)
    {
        return axios.post(admin+"user/addCategory", JSON.stringify(data),  header)
    },
    addSong(data)
    {
        return axios.post(admin+"user/addSong", JSON.stringify(data),  header)
    },
    updateSong(data)
    {
        return axios.post(admin+"user/updateSong", JSON.stringify(data),  header)
    },
    deleteSong(data)
    {
        return axios.post(admin+"user/deleteSong", JSON.stringify(data),  header)
    },
    AlbumList_byID(data)
    {
        return axios.post(master+"user/AlbumMasterList", JSON.stringify(data),  header)
    },
    AlbumList(data)
    {
        return axios.post(master+"user/AlbumMasterList", JSON.stringify(data),  header)
    },
    AlbumAdd(data)
    {
        return axios.post(master+"user/AlbumAdd", JSON.stringify(data),  header)
    },
    AlbumEdit(data)
    {
        return axios.post(master+"user/AlbumEdit", JSON.stringify(data),  header)
    },
    AlbumDelete(data)
    {
        return axios.post(master+"user/AlbumDelete", JSON.stringify(data),  header)
    },
    UpdateCategory(data)
    {
        return axios.post(master+"user/updateCategory", JSON.stringify(data),  header)
    },
    CategoryDelete(data)
    {
        return axios.post(master+"user/deleteCategory", JSON.stringify(data),  header)
    },
    generateqr(data)
    {
        return axios.post(master + "user/generateqr", JSON.stringify(data),  header)
    },
    lockunlockVehicle(data)
    {
        return axios.post(master + "user/lockunlockVehicle", JSON.stringify(data),  header)
    },
  


}